import {
  SlCarousel
} from "./chunk.KLASTODS.js";

// src/components/carousel/carousel.ts
var carousel_default = SlCarousel;
SlCarousel.define("sl-carousel");

export {
  carousel_default
};
